import { ZONE_KIND_COLORS, type ZoneKindColor } from '@chukua/common';
import type { CSSProperties } from 'react';

/**
 * The dot a zone kind is drawn in on the Zones map — beside its name in tables, pickers and the map legend.
 * It takes the shade for the colour mode, as the map does, from CSS, so it needs no colour-mode context.
 */
export function ZoneKindSwatch({ color }: { color: ZoneKindColor }) {
  const shades = { '--swatch-light': ZONE_KIND_COLORS[color].light, '--swatch-dark': ZONE_KIND_COLORS[color].dark } as CSSProperties;
  return <span aria-hidden className="inline-block size-3 shrink-0 rounded-full bg-(--swatch-light) dark:bg-(--swatch-dark)" style={shades} />;
}
